import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { setupInterceptorsTo } from "../api/Interceptors";
import { URL_ENDPOINTS } from "./../constants";

export const axiosInstance = setupInterceptorsTo(
  axios.create({
    baseURL: URL_ENDPOINTS.BASE_URL,
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: false,
  }),
);

const Api = {
  GET: async (URL: string, params?: object) => {
    const options = {
      params,
    };
    const request = await axiosInstance.get(URL, options);

    return request;
  },
  POST: async (
    URL: string,
    data: object | string,
    config?: AxiosRequestConfig,
  ): Promise<AxiosResponse<any, any>> => {
    const request = await axiosInstance.post(URL, data, config);
    return request;
  },
  PUT: async (URL: string, data: object): Promise<AxiosResponse<any, any>> => {
    const request = await axiosInstance.put(URL, data);

    return request;
  },
};

export default Api;
